import { render, staticRenderFns } from "./EditActivityImage.vue?vue&type=template&id=908097b6&scoped=true"
import script from "./EditActivityImage.vue?vue&type=script&lang=js"
export * from "./EditActivityImage.vue?vue&type=script&lang=js"
import style0 from "./EditActivityImage.vue?vue&type=style&index=0&id=908097b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908097b6",
  null
  
)

export default component.exports